import script from "./TcAvatar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TcAvatar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./TcAvatar.vue.scss?vue&type=style&index=0&id=b9b3f3ff&lang=scss!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcAvatar.vue?vue&type=style&index=0&id=b9b3f3ff&lang=scss"

const __exports__ = script;

export default __exports__